import React from "react";
import App from "../controllers/App/App";
import AppNewLogic from "../controllers/App/AppNewLogic";
import { HeroBanner } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import FileMessageSalesSubmissionInformation from "../components/FileMessageSalesSubmissionInformation/FileMessageSalesSubmissionInformation";
import { Task } from "mosaic-react-icons";
import { MultipleDownloadButton } from "../components/MultipleDownloadButton/MultipleDownloadButton";
import ReportingDateHeader from "../components/ReportingDateHeader/ReportingDateHeader";
import { controllerQueries } from "../controllers/utils/utils";
import { hasModule } from "../utils/utils";

const OverviewController = (props) => {
    const { modules } = props;
    const modifiedProps = { ...props, hasHeroBanner: true }
    const Controller = hasModule(modules, "new_navigation") ? AppNewLogic : App;
    return <Controller {...modifiedProps} />;
};




const queries = (args = {}) => {
    const viewMode = args.viewMode;

    return args.fiscalYear
        ? [
            {
                //to defer old core of the new core -> full old core navigation
                resource: "nc_audit_summary",
                args: {
                    projectId: args.projectId,
                    fiscalYear: args.fiscalYear,
                    importId: args.importId,
                    modulePrefix: args.modulePrefix,
                    ...(viewMode && { viewMode }), // Add viewMode if it exists
                },
                body: "severity, count",
            },
            {
                resource: "generic_overview",
                args: {
                    projectId: args.projectId,
                    fiscalYear: args.fiscalYear,
                    importId: args.importId,
                    modulePrefix: args.modulePrefix,
                    locale: args.locale,
                    filters: args.filter
                        ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                        : undefined,
                    ...(viewMode && { viewMode }),
                },
            },
            {
                resource: "generic_overview_export",
                args: {
                    projectId: args.projectId,
                    fiscalYear: args.fiscalYear,
                    importId: args.importId,
                    modulePrefix: args.modulePrefix,
                    filters: args.filter
                        ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                        : undefined,
                    ...(viewMode && { viewMode }), // Add viewMode if it exists
                },
                body: "report",
                downloadable: true,
                downloadOnly: true,
                xlsxTranslation: "overview",
            },
            {
                resource: "submission_files_repository",
                args: {
                    projectId: args.projectId,
                    fiscalYear: args.fiscalYear,
                    importId: args.importId,
                    modulePrefix: args.modulePrefix,
                    ...(viewMode && { viewMode }), // Add viewMode if it exists
                },
                body: "status, files, fileType",
            },
            {
                resource: "data_files_types_present",
                args: {
                    projectId: args.projectId,
                },
                forceRefresh: true,
                body: "hasSource, hasLegal",
            },
        ]
        : [];
};
OverviewController.queries = (args, userModulesByProject) => {
    return controllerQueries(args, userModulesByProject);
};

const genericOverview = (path, navigation, exact, title, navByImportId = false, staticParams = {}) => {
    const component = (props) => OverviewController({ ...props, ...staticParams }, navByImportId);
    component.queries = (args = {}, userModulesByProject) =>
        OverviewController.queries(args, userModulesByProject);

    return {
        path,
        navigation,
        component,
        queries: (args = {}) => queries({ ...staticParams, ...args }),
        exact,
        navByImportId,
        title: [title],
        headerComponentConfigs: {
            showButton: true,
            label: "Download",
            items: [{ menuLabel: "Excel" }],
        },
        hasSource: "query(4).hasSource",
        hasLegal: "query(4).hasLegal",
        headerComponents: [
            { component: ReportingDateHeader, props: { allowWithoutAvailableFilters: true, width: "220px" }, inline: true },
            { component: MultipleDownloadButton },
        ],
        isOverview: true,
        components: [
            {
                component: FileMessageSalesSubmissionInformation,
                props: {
                    mergeRepository: "query(3)",
                },
            },
            {
                component: HeroBanner,
                modifiers: ["--root-margin-bottom-normal"],
                props: {
                    icon: Task,
                    title: "label(Audit Results)",
                    summary: "query(0).list",
                    link: {
                        to: `/:projectId/:fiscalYear/:importId/nc_audit`,
                        name: "label(View all)",
                        createLink: true,
                    },
                    overviewSummaryWidget: true,
                },
            },
        ],
    };
};

export default genericOverview;
